/* eslint-disable max-len */
import React, { useEffect } from "react"
import { useState ,useContext} from "react"
import GlobalContext from "../../../../components/Context/GloablContext"
import formatMobileNumber from "../../../../CommonMethods/FormatMobileNumber"
import CustomOverLay from "../../../../components/CustomOverLay"
import {motion} from 'framer-motion'
import Emptyscreenwithouttitle from "../../../../components/Emptyscreenwithouttitle"
import AnimatedModel from "../../../../components/Animation/AnimatedModel"
import ConfirmationPrompt from "../../../../components/ConfirmationPrompt"
import { useUpdateMonitorPermissionMutation } from "../../../../features/patientSlice"

export default function MonitoringTable({monitorResult,setIsObserverAddOrDelete,setIsProviderAddOrDelete,handleDeleteAssociatedOrganization,setIsAnyFieldFilled,isAllSelected,setIsAllSelected,permissionAccess,setPermissionAccess,subdivision_id,patient_id,changeAccess,setChangeAccess,monitorSmsAlert,setMonitorSmsAlert,monitorEmailAlert,setMonitorEmailAlert,monitorMissedReading,setMonitorMissedReading}){
   
    const { setToastmessage,setToastErrorMessage ,isSideBar} = useContext(GlobalContext)
    const [updateMonitorPermissionAccess] = useUpdateMonitorPermissionMutation()
    const [hoverProperties,setHoverProperties] = useState({
        'hover':'',
        'hover_index':'',
        'index_to_display_modal':''
    })
    const [loading,setLoading] = useState(false)

    useEffect(()=>{
        setChangeAccess(monitorResult?.data?.data?.map((item)=>item?.monitor_permission))
        setMonitorSmsAlert(monitorResult?.data?.data?.map((item)=>item?.sms_alert === true))
        setMonitorEmailAlert(monitorResult?.data?.data?.map((item)=>item?.email_alert === true))
        setMonitorMissedReading(monitorResult?.data?.data?.map((item)=>item?.missed_reading_alert === true))
    },[monitorResult])

    const handleOnCLickActivate = async(e) => {
        try {
            let body = { }
            if(permissionAccess==='view'){
                body={
                    "users": monitorResult?.data?.data?.map((item)=>item?.monitorUserData?.user_id),
                    "permission":'view',
                    "subdivision_id" : subdivision_id 
                } 
            }

            else{
                body={
                    "users": monitorResult?.data?.data?.map((item)=>item?.monitorUserData?.user_id),
                    "permission":'monitor',
                    "subdivision_id" : subdivision_id
                        
                }
            }
            setLoading(true)
            
            
            const activationRes=await updateMonitorPermissionAccess({patient_id,body})
            setLoading(false)
            
            if(activationRes?.error){
                setToastErrorMessage('Something went wrong. Please try again')
            }else{
                setToastmessage(`Permission Access changed to ${permissionAccess} successfully`)
                
            }
            setPermissionAccess('')
            setIsAllSelected(false)
           
        } catch (error) {
            setPermissionAccess('')
            setIsAllSelected(false)
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }  

    const handleConformationClick = () => {
        setPermissionAccess('')   
    }
    return(
        <div className='overflow-auto scrollbar_purple pb-2.5 border border-[#EDD7E1] rounded-lg'>
            {monitorResult.status === 'pending' ||monitorResult===undefined
                ? <CustomOverLay Active text="Loading Monitor Details..." classKey={`  h-[100px] left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_monitor_overlay3' : 'overlay-list-monitor3'}`} />
                : 
                monitorResult?.data?.data?.length>0?<table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-[0px] left-0 z-[1]">
                            <th className="px-[13px] py-2 rounded-tl-sm rounded-bl-sm flex items-center min-w-[150px]">
                                <div className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id="select_all_name" checked={isAllSelected} onChange={()=>{setIsAllSelected(!isAllSelected)}}/>
                                    <label htmlFor="select_all_name" className="text-sm font-normal text-[#031624] w-full cursor-pointer pl-4">Monitor ID</label>
                                </div>
                                                                
                            </th>
                            <th id="last" className="px-[18px] py-2 min-w-[130px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Monitor Name
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]" >Main Number
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[150px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Permission Access
                                </span>
                            </th>
                            <th className="px-[18px] py-2 xl:min-w-[180px] min-w-[200px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[150px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alerts by SMS
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[150px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alerts by Email
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[150px] whitespace-nowrap">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Include Missed Readings
                                </span>
                            </th>
                            <th className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[-1px] bg-[#EDD7E1] xl:min-w-[70px] min-w-[120px]">
                                <span className="flex items-center justify-center text-sm font-normal text-[#000000]">Remove
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {monitorResult?.data?.data?.map((item,index)=>{let monitorName= [item?.monitorUserData?.first_name, item?.monitorUserData?.last_name].filter(Boolean).join(' ')
                            return(<tr key={index}>
                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px] prevent-click">
                                    {item?.monitorUserData?.user_id}
                                </td>
                            
                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{monitorName}</td>
                       
                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.monitorUserData?.main_country_code} {formatMobileNumber(item?.monitorUserData?.main_number)}</td>
                                <td className="px-[18px] py-2 text-sm text-start font-normal bg-[#FFF] text-[#031624]">
                                    <div className='border border-[#C5C9DA] rounded-[16px] p-1 w-max'>
                                        <button onClick={()=>{setChangeAccess((prev)=>([...prev.slice(0,index),"view",...prev.slice(index+1)])),setIsAnyFieldFilled(true)}} className={`px-3 py-1.5 text-sm font-semibold text-[#777C88] rounded-[12px] mr-1 ${changeAccess[index]==="view"?'permission_access':''}`}>
                                            View
                                        </button>
                                        <button onClick={()=>{setChangeAccess((prev)=>([...prev.slice(0,index),"monitor",...prev.slice(index+1)])),setIsAnyFieldFilled(true)}} className={`px-3 py-1.5 text-sm font-semibold text-[#777C88] rounded-[12px] ${changeAccess[index]==="monitor"?'permission_access':''}`}>
                                            Monitor
                                        </button>
                                    </div>
                                </td>
                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                    {item?.mobile_country_code ? `${item?.mobile_country_code} ${formatMobileNumber(item?.mobile_number || '')}` : item?.monitorUserData?.mobile_country_code ? `${item?.monitorUserData?.mobile_country_code} ${formatMobileNumber(item?.monitorUserData?.mobile_number || '')}` : '-'}
                                </td>
                                <td className="px-[20px] py-2 text-sm text-start font-normal text-[#031624]">  <div className="status custom-toggle flex items-center ">
                                        <label className="switch" style={{marginLeft: '10px'}}>
                                            <input 
                                                type="checkbox"  
                                                onChange={(e)=>{
                                                    const newSmsAlerts = [...monitorSmsAlert.slice(0,index),!monitorSmsAlert[index],...monitorSmsAlert.slice(index+1)];
                                                    
                                                    // Allow toggling - validation will happen on submit
                                                    setMonitorSmsAlert(newSmsAlerts);
                                                    setIsAnyFieldFilled(true);
                                                }} 
                                                checked={monitorSmsAlert[index] || false} 
                                                disabled={!item?.monitorUserData?.main_number || item?.monitorUserData?.main_number?.trim() === ""}
                                            />
                                            <span id={`${index}monitorsms`} className="slider round"></span>
                                        </label></div></td>
                                <td className="px-[20px] py-2 text-sm text-start font-normal text-[#031624]">  <div className="status custom-toggle flex items-center ">
                                        <label className="switch" style={{marginLeft: '10px'}}>
                                            <input 
                                                type="checkbox"  
                                                onChange={(e)=>{
                                                    const currentValue = monitorEmailAlert[index];
                                                    const newValue = !currentValue;
                                                    const newEmailAlerts = [...monitorEmailAlert.slice(0,index), newValue,...monitorEmailAlert.slice(index+1)];
                                                    
                                                    // Allow toggling - validation will happen on submit
                                                    setMonitorEmailAlert(newEmailAlerts);
                                                    setIsAnyFieldFilled(true);
                                                }} 
                                                checked={monitorEmailAlert[index] || false}
                                            />
                                            <span id={`${index}monitoremail`} className="slider round"></span>
                                        </label></div></td>
                                <td className="px-[20px] py-2 text-sm text-start font-normal text-[#031624]">  <div className="status custom-toggle flex items-center ">
                                        <label className="switch" style={{marginLeft: '10px'}}>
                                            <input 
                                                type="checkbox"  
                                                onChange={(e)=>{
                                                    setMonitorMissedReading((prev)=>([...prev.slice(0,index),!monitorMissedReading[index],...prev.slice(index+1)])),setIsAnyFieldFilled(true)
                                                }} 
                                                checked={monitorMissedReading[index] || false} 
                                            />
                                            <span id={`${index}monitormissed`} className="slider round"></span>
                                        </label></div></td>
                                <td onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'modify',hover_index:index}))}} 
                                    onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}} className="px-[12px] py-2 bg-[#FFF] text-sm text-center font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[-1px]">
                               
                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index ))?<>
                                        <motion.div
                                            initial={{ opacity: 1, x: 0,y:0 }}
                                            animate={{ opacity: 1, x: -40 ,y:0}}
                                            transition={{ delay: 0.2, duration: 0.5 }}
                                            exit={{ opacity: 0,x:0,transition: { duration: 0.5 ,delay:0.9} }}
                                            className=''
                                        >
                                            <button onClick={()=>{handleDeleteAssociatedOrganization(item,index)}}>
                                                <img loading='lazy' decoding='async' src="/images/deleteicon-pink.svg" className="mx-auto w-5 mr-3" alt="icon" />
                                            </button>
                                        </motion.div>
                                    
                                    </>: <button id="remove" onClick={()=>{handleDeleteAssociatedOrganization(item,index)}}>
                                        <img loading='lazy'  decoding='async' src="/images/deleteicon-pink.svg" className="mx-auto w-5 mr-3" alt="icon" />
                                    </button>}
                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index )) &&
                                    <motion.div
                                        initial={{ opacity: 0, x: 0,y:0 }}
                                        animate={{ opacity: 1, x: 0 ,y:0}}
                                        transition={{ delay: 0.2, duration: 0.5 }}
                                        exit={{ opacity: 0,x:0,transition: { duration: 0.5 ,delay:0.9} }}
                                        className=''
                                    >
                                        
                                        <div className='relative ml-2 cursor-pointer mt-[-25px]' onClick={()=>{handleDeleteAssociatedOrganization(item,index),setIsProviderAddOrDelete(false),setIsObserverAddOrDelete(false)}} >
                                        
                                            <p className="text-sm  font-normal text-[#972E4C] ">Remove</p>
                                       
                                        </div>
                                    </motion.div>
                                   
                                    }
                                </td>
                            </tr>)})}
                    </tbody>
                    <>
                        {permissionAccess!==''  && 
                        <AnimatedModel 
                            Children={
                                <ConfirmationPrompt
                                    emptyField={''}
                                    setEmptyField={()=>{}}
                                    handleOnCLickActivate={handleOnCLickActivate}
                                    handleClose={handleConformationClick}
                                    tittle= {'Change Permission Access'}
                                    message = {`Are you sure you want to change the permission access to ${permissionAccess}?`}
                                    textMessage = {false}
                                    buttonName = {'Yes'}
                                    userList={''}
                                    disabled={loading}
                                    loadingActivation={loading}
                                />
                            }
                        /> 
                        }
                    </>
                </table>:<Emptyscreenwithouttitle   FirstPTag={"No monitors linked yet"} customHeight={true} />}
        </div>
    )
}